import { getRequest, putRequest } from "../system/server-calls";
import responseHandler from "../system/server-response-handler";

const addOrUpdatePrivacyPolicy = (data) =>
  putRequest("PrivacyPolicy", data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

  const getPrivacyPolicy = () =>
  getRequest("PrivacyPolicy").then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

export const privacyPolicyService = {
  addOrUpdatePrivacyPolicy,
  getPrivacyPolicy,
};
